import Vue from 'vue'
import App from './App.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueScrollTo from 'vue-scrollto'

library.add(fas, far, fab)

Vue.component('font-awesome-icon', FontAwesomeIcon)

const moment = require('moment')
require('moment/locale/it')

Vue.use(require('vue-moment'), {moment})
Vue.use(VueScrollTo)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  data: {
    lang: ''
  },
  methods: {
	  setLanguage(id, name) {
		  this.lang = {
			  id,
			  name
		  };
      this.$moment.locale(id);
	  },
    getLanguageFromId(id) {
      if (id == 'it')
        return {
          id: 'it',
          literal: 'Italiano'
        }
      return {
        id: 'en',
        literal: 'English'
      }
    }
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('lang') == 'en' || !urlParams.get('lang') && window.navigator.language.split('-')[0] == 'en')
      this.setLanguage('en', 'English')
    else
      this.setLanguage('it', 'Italiano');
      
  },
  computed: {}
}).$mount('#app')
